let Abacus = {
	version: "2.01.0.1",
	PreventDefault: {},
	InitUI: function(){},
	capableBrowser: (!(navigator.userAgent.indexOf('Android') >= 0) || (navigator.userAgent.indexOf('Android') >= 0) && navigator.userAgent.slice(navigator.userAgent.indexOf('Android')+8) >= '3'),
	WindowsTablet: (navigator.platform.toLowerCase().indexOf('win') !== -1 && navigator.userAgent.toLowerCase().indexOf('touch') !== -1),
	IEMobile: (navigator.userAgent.match(/IEMobile/i)),
	isNativeAndroid: function() { // Fix for popups - native browser does not like transitions
		var isAndroid = navigator.userAgent.indexOf('Android') >= 0;
		var webkitVer = parseInt((/WebKit\/([0-9]+)/.exec(navigator.appVersion) || 0)[1],10) || void 0; // also match AppleWebKit
		var isNativeAndroid = isAndroid && webkitVer <= 534 && navigator.vendor.indexOf('Google') == 0;
		return isNativeAndroid;
	},
	Debug: false,
	Lang: {
		core: {
			more: {
				'default': 'Show more',
				searchtype: 'Show more',
				searchdates: 'Show more'
			},
			less: {
				'default': 'Show fewer',
				searchtype: 'Show fewer',
				searchdates: 'Show fewer'
			},
			show: {
				'default': 'show'
			},
			hide: {
				'default': 'hide'
			},
			caption: {
				show: 'Show caption',
				hide: 'Hide caption'
			},
			carousel: {
				play: 'play slideshow',
				pause: 'pause slideshow'
			}
		}
	}
};

if(typeof newLang !== 'undefined') {
	Abacus.Lang.core = newLang;
}

export { Abacus };


// WEBPACK FOOTER //
// ./Javascript/core/Abacus.Core.js